export const USER_DATA_CHANGED = 'USER_DATA_CHANGED';

export const USER_WITHDREW = 'USER_WITHDREW';
